import React from 'react';

const NoResults = () => {
  return <div data-testid='topics-no-results'>NO TOPICS</div>;
};

export default NoResults;
